/**
 * @file 誕生日分割
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname SplitBirthday2
 * @classdesc 年作成
 */
export default class SplitBirthday2 {
	/**
	 * @constructor
	 * @param {jQuery} $e - .celebration_message_birthday
	 */
	constructor($e) {
		console.log('SplitBirthday2.constructor');
		let birthday = $e.val();
		if(birthday && birthday !== ''){
			birthday = birthday.split('/');
			const year = birthday[0];
			const month = birthday[1];
			const day = birthday[2];
			console.log(`${year}${month}${day}`);
			const lastDay = Common.getDateFromYearMonth(year, parseInt(month));
			console.log(lastDay);
			let options = '<option value="">--</option>';
			for(let i = 0; i <= lastDay; i++){
				options += `<option value="${Common.zeroPadding(i, 2)}">${Common.zeroPadding(i,2)}</option>`;
			}
			$('.celebration_message_birth_date').html(options);
			let cnt = 0;
			const timer = setInterval(() => {
				$e.closest('.form-group__content').find('.celebration_message_birth_year').val(year);
				$e.closest('.form-group__content').find('.celebration_message_birth_month').val(month);
				$e.closest('.form-group__content').find('.celebration_message_birth_date').val(day);
				if(cnt > 2){
					clearInterval(timer);
				}
				cnt ++;
				console.log('SET INTERVAL2');
			},500);
		}
	};
}
